export const tickerItems = [
  "【综艺】某音乐竞演节目后台排练花絮被现场观众讨论",
  "【影视】新剧开播口碑讨论升温，观众聚焦角色设定",
  "【直播】主播连麦名场面合集在社区被反复转发",
  "【音乐】新歌首发现场路透引发现场观众围观",
  "【赛场】运动赛事赛后发布会细节成为话题焦点",
  "【时尚】红毯造型穿搭讨论登上今日热门板块",
  "【论坛】本周「围观现场」版块新增讨论帖 1,286 条",
];

export const navItems = [
  { id: "hot", label: "今日热议" },
  { id: "latest", label: "最新吃瓜" },
  { id: "forum", label: "论坛版块" },
  { id: "group", label: "吃瓜群" },
  { id: "live", label: "围观现场" },
  { id: "guide", label: "入门规则" },
  { id: "faq", label: "常见问答" },
];

export const hotRanges = [
  { key: "hour", label: "1 小时" },
  { key: "day", label: "24 小时" },
  { key: "week", label: "本周" },
] as const;

export type HotRange = (typeof hotRanges)[number]["key"];

export const hotTopics: Record<HotRange, { rank: number; title: string; tag: string; heat: number; trend: string; replies: number }[]> = {
  hour: [
    { rank: 1, title: "音乐竞演节目最新一期排练片段流出，现场观众描述各有说法", tag: "综艺", heat: 98200, trend: "+42%", replies: 864 },
    { rank: 2, title: "新剧开播首周收视数据公布，剧粉与路人观众观点出现分歧", tag: "影视", heat: 74600, trend: "+38%", replies: 612 },
    { rank: 3, title: "红毯造型合集被搬运到社区，穿搭细节成为讨论重点", tag: "时尚", heat: 61500, trend: "+27%", replies: 533 },
    { rank: 4, title: "主播连麦现场名场面，弹幕刷屏片段被剪成合集", tag: "直播", heat: 52900, trend: "+19%", replies: 471 },
    { rank: 5, title: "新歌上线首小时评论区热闹，制作阵容信息被网友整理", tag: "音乐", heat: 47300, trend: "+15%", replies: 398 },
    { rank: 6, title: "运动赛事赛后发布会问答片段，被现场记者发到社交平台", tag: "赛场", heat: 41800, trend: "+12%", replies: 356 },
    { rank: 7, title: "某综艺游戏环节规则被观众讨论，弹幕评论区各执一词", tag: "综艺", heat: 38600, trend: "+9%", replies: 322 },
    { rank: 8, title: "剧组路透照被路人拍下，造型妆发成为新的话题点", tag: "影视", heat: 35100, trend: "+7%", replies: 289 },
  ],
  day: [
    { rank: 1, title: "「围观现场」版块昨新增帖破千，音乐竞演话题持续发酵", tag: "论坛", heat: 156800, trend: "+61%", replies: 1342 },
    { rank: 2, title: "新剧角色设定引发原著党与剧党讨论，讨论帖已经盖到五百楼", tag: "影视", heat: 128400, trend: "+47%", replies: 1108 },
    { rank: 3, title: "时尚周前排座位图被网友逐一辨认，穿搭与座位同时上热门", tag: "时尚", heat: 96400, trend: "+33%", replies: 875 },
    { rank: 4, title: "电竞小组赛冷门赛果讨论，赛后复盘帖在社区被反复引用", tag: "赛场", heat: 88700, trend: "+29%", replies: 792 },
    { rank: 5, title: "歌手新专辑封面与视觉被放大解读，设计师信息被扒出整理", tag: "音乐", heat: 76300, trend: "+24%", replies: 668 },
    { rank: 6, title: "晚会节目单提前流出，观众按节目顺序开启赛前预测", tag: "综艺", heat: 68900, trend: "+21%", replies: 601 },
    { rank: 7, title: "直播带货现场口误片段被剪出，评论区讨论是否会被玩成梗", tag: "直播", heat: 61200, trend: "+18%", replies: 540 },
    { rank: 8, title: "某剧组杀青照曝光，演员阵容与番位顺序成为讨论话题", tag: "影视", heat: 55700, trend: "+14%", replies: 486 },
  ],
  week: [
    { rank: 1, title: "本周吃瓜大事记：从综艺现场到影视开播，讨论热度一路走高", tag: "论坛", heat: 342000, trend: "+88%", replies: 2861 },
    { rank: 2, title: "音乐竞演节目整季排名讨论，观众整理的「名场面」时间线被置顶", tag: "综艺", heat: 298500, trend: "+72%", replies: 2403 },
    { rank: 3, title: "两部新剧同期开播，收视与口碑对比帖成为社区周榜常客", tag: "影视", heat: 254700, trend: "+58%", replies: 2137 },
    { rank: 4, title: "红毯季盘点：一周造型合集与最佳穿搭投票结果出炉", tag: "时尚", heat: 208900, trend: "+44%", replies: 1782 },
    { rank: 5, title: "电竞与体育赛事跨周回顾，赛后采访合集被整理成贴", tag: "赛场", heat: 187600, trend: "+37%", replies: 1564 },
    { rank: 6, title: "本周新歌与新专辑听感讨论，乐评区高赞长文被频繁转载", tag: "音乐", heat: 163400, trend: "+31%", replies: 1398 },
    { rank: 7, title: "直播周榜：互动名场面与高能切片合集持续霸榜", tag: "直播", heat: 142800, trend: "+26%", replies: 1207 },
    { rank: 8, title: "社区新人指南帖一周新增收藏过万，版规科普帖被同步置顶", tag: "论坛", heat: 121500, trend: "+22%", replies: 1043 },
  ],
};

export const feedCategories = ["全部", "综艺", "影视", "音乐", "直播", "时尚", "赛场", "论坛"] as const;
export type FeedCategory = (typeof feedCategories)[number];

export const feedItems: {
  id: number;
  category: Exclude<FeedCategory, "全部">;
  title: string;
  summary: string;
  author: string;
  time: string;
  replies: number;
  heat: string;
  hot: boolean;
}[] = [
  {
    id: 1,
    category: "综艺",
    title: "音乐竞演节目排练花絮流出，现场观众各说各的",
    summary: "节目组放出的排练花絮里，几位选手的互动被观众反复回看。有人觉得气氛轻松，也有人认为剪辑顺序做了调整。讨论帖内附上了观众整理的时间线对比，供大家自行判断。",
    author: "前排吃瓜选手",
    time: "12 分钟前",
    replies: 264,
    heat: "9.8 万",
    hot: true,
  },
  {
    id: 2,
    category: "影视",
    title: "新剧开播口碑两极，原著党与剧党各有一派观点",
    summary: "开播首周，角色设定与原著差异成为最集中的讨论点。支持者认为改编更贴合节奏，反对者则列出被删减的情节清单。帖内还贴出了编剧过往作品，方便对照参考。",
    author: "追剧不睡觉",
    time: "38 分钟前",
    replies: 198,
    heat: "7.4 万",
    hot: true,
  },
  {
    id: 3,
    category: "时尚",
    title: "红毯造型合集更新，穿搭细节被逐个放大讨论",
    summary: "最新一场红毯的造型图被整理成九宫格，配饰、妆发与礼服剪裁都成了话题。社区里有人做了同色系穿搭对比，也有人只看整体氛围感，评论区风格差异明显。",
    author: "时尚观察员",
    time: "1 小时前",
    replies: 156,
    heat: "6.1 万",
    hot: false,
  },
  {
    id: 4,
    category: "直播",
    title: "主播连麦名场面合集，弹幕高能片段被剪成短片",
    summary: "昨晚一场连麦直播中出现多个高能瞬间，粉丝把弹幕与画面时间点对齐后做成合集。帖内说明仅在社区内部围观，并提醒不要搬运到其他平台引发误读。",
    author: "直播间观众",
    time: "2 小时前",
    replies: 132,
    heat: "5.3 万",
    hot: false,
  },
  {
    id: 5,
    category: "音乐",
    title: "新歌上线首小时，制作阵容信息被网友整理成表",
    summary: "新歌发布后，编曲、作词与制作人的名单被社区网友整理成一张对照表。有乐迷从配器角度分析听感变化，也有人更关注副歌的记忆点。",
    author: "耳机常驻",
    time: "3 小时前",
    replies: 118,
    heat: "4.7 万",
    hot: false,
  },
  {
    id: 6,
    category: "赛场",
    title: "赛后发布会问答片段，被现场记者发到社交平台",
    summary: "一场焦点赛事的赛后发布会中，几段问答被现场记者拍下并发布。社区帖内只做信息汇总，并标注了来源时间，讨论集中在赛果与技战术层面。",
    author: "看台上的人",
    time: "4 小时前",
    replies: 97,
    heat: "4.1 万",
    hot: false,
  },
  {
    id: 7,
    category: "论坛",
    title: "本周社区大事记：新人指南帖收藏过万",
    summary: "版务整理的本周大事记已经更新，涵盖热门讨论、被置顶的科普帖与规则提醒。新手建议先看指南再发帖，老用户也可以在帖内补充自己踩过的坑。",
    author: "版务小助手",
    time: "5 小时前",
    replies: 88,
    heat: "3.8 万",
    hot: false,
  },
  {
    id: 8,
    category: "综艺",
    title: "综艺游戏环节规则被逐条解读，观众各执一词",
    summary: "新一期综艺上线后，游戏环节的计分规则被观众逐条拆解。有人按规则推演结果，也有人认为现场剪辑留下了信息缺口，帖内把两种说法都列了出来。",
    author: "规则研究员",
    time: "6 小时前",
    replies: 76,
    heat: "3.5 万",
    hot: false,
  },
  {
    id: 9,
    category: "影视",
    title: "剧组路透照被路人拍下，造型妆发成新话题点",
    summary: "有路人拍到剧组外景拍摄的路透照并发布，造型与妆发迅速成为讨论点。帖子提醒路透信息未经官方确认，仅供围观参考，请勿当作既定事实传播。",
    author: "路过片场",
    time: "7 小时前",
    replies: 64,
    heat: "3.2 万",
    hot: false,
  },
  {
    id: 10,
    category: "音乐",
    title: "音乐节现场歌单流出，观众按顺序复盘整场演出",
    summary: "一场音乐节的现场歌单被观众按序整理出来，并标注了大致的换场时间。帖内还附上了现场氛围描述，方便没到场的乐迷了解整场节奏。",
    author: "草地第一排",
    time: "8 小时前",
    replies: 55,
    heat: "2.9 万",
    hot: false,
  },
  {
    id: 11,
    category: "直播",
    title: "带货直播口误片段被剪出，评论区玩梗与提醒并存",
    summary: "一段直播口误被观众剪出并加上了时间戳。评论区一半在玩梗，另一半提醒注意信息准确性，不要断章取义转发到站外。",
    author: "手速很快",
    time: "9 小时前",
    replies: 48,
    heat: "2.6 万",
    hot: false,
  },
  {
    id: 12,
    category: "赛场",
    title: "小组赛冷门赛果复盘帖，被社区反复引用",
    summary: "一场冷门赛果的复盘帖用数据还原了关键节点，被多个讨论帖引用。作者强调数据来自公开统计，结论仅供参考，欢迎补充不同视角。",
    author: "数据面板",
    time: "10 小时前",
    replies: 41,
    heat: "2.3 万",
    hot: false,
  },
];

export const forumBoards = [
  { icon: "ri-tv-2-line", name: "综艺现场", desc: "节目花絮、录制路透与弹幕名场面集中讨论区", threads: "8,642", today: 326, role: "primary" },
  { icon: "ri-film-line", name: "影视追更", desc: "新剧开播、角色设定与选角话题的追剧主阵地", threads: "7,215", today: 288, role: "accent" },
  { icon: "ri-music-2-line", name: "音乐前线", desc: "新歌上线、专辑听感与现场演出的交流版块", threads: "5,904", today: 214, role: "secondary" },
  { icon: "ri-live-line", name: "直播围观", desc: "直播间高能切片、连麦名场面与互动讨论", threads: "6,388", today: 251, role: "primary" },
  { icon: "ri-t-shirt-line", name: "时尚造型", desc: "红毯、杂志与街拍的穿搭拆解和造型投票", threads: "4,127", today: 163, role: "accent" },
  { icon: "ri-basketball-line", name: "赛场看台", desc: "赛事复盘、赛后采访与技战术的理性讨论", threads: "3,860", today: 142, role: "secondary" },
  { icon: "ri-chat-smile-2-line", name: "闲聊灌水", desc: "日常唠嗑、冷笑话与站内互助，气氛最轻松", threads: "12,507", today: 402, role: "primary" },
  { icon: "ri-shield-check-line", name: "站务公告", desc: "版规更新、举报处理与新人指南的官方版块", threads: "1,096", today: 58, role: "accent" },
];

export const groupEntries = [
  {
    icon: "ri-group-line",
    name: "综合吃瓜大群",
    members: "3,286 人",
    desc: "覆盖综艺、影视、音乐等全品类话题，适合刚入门的新人先来熟悉节奏。",
    note: "入群后请先阅读置顶规则",
  },
  {
    icon: "ri-music-line",
    name: "音乐 & 现场讨论群",
    members: "1,742 人",
    desc: "专注新歌、专辑听感与音乐节现场，讨论氛围偏理性，适合乐迷长期蹲守。",
    note: "欢迎分享歌单与现场记录",
  },
  {
    icon: "ri-movie-2-line",
    name: "追剧 & 影视群",
    members: "2,105 人",
    desc: "新剧开播第一时间交流，角色设定与剧情走向都可以在群内开聊。",
    note: "剧透请自觉加提醒前缀",
  },
  {
    icon: "ri-shield-star-line",
    name: "新人答疑群",
    members: "968 人",
    desc: "不清楚版规、不会发帖、找不到入口的问题都可以在这里问，版务会统一回复。",
    note: "仅答疑，不接受广告",
  },
];

export const liveTimeline = [
  { time: "今天 09:42", tag: "综艺", title: "音乐竞演节目花絮贴发布", desc: "现场观众发帖描述录制间隙的互动，附上观众整理的时间线对比图。" },
  { time: "今天 10:15", tag: "论坛", title: "围观现场版块热度突破万级", desc: "版内新增讨论帖持续增加，版务将高频话题整理成合集并置顶。" },
  { time: "今天 11:07", tag: "影视", title: "新剧口碑对比帖更新第二轮", desc: "原著党与剧党各自补充论据，帖子被推荐到站内首页曝光位。" },
  { time: "今天 12:30", tag: "时尚", title: "红毯造型九宫格合集上线", desc: "社区用户在帖内发起同色系穿搭对比，评论区参与投票。" },
  { time: "今天 14:08", tag: "直播", title: "连麦名场面短片被剪出", desc: "粉丝把弹幕与画面时间点对齐，帖内提醒不要搬运到站外。" },
  { time: "今天 16:25", tag: "赛场", title: "冷门赛果数据复盘帖发布", desc: "作者用公开统计数据还原关键节点，强调结论仅供讨论参考。" },
];

export const guideSteps = [
  { step: "01", title: "先看新人指南", desc: "进入社区第一步先阅读站务公告版块的新人指南，了解发帖格式与版块划分，少走弯路。" },
  { step: "02", title: "选一个版块蹲守", desc: "从你感兴趣的分类进入对应版块，先观察几天的讨论节奏，再决定要不要参与发帖。" },
  { step: "03", title: "加入一个吃瓜群", desc: "想更快跟上实时讨论，可以按兴趣加入对应的吃瓜群，群内节奏更快、信息更及时。" },
  { step: "04", title: "理性围观再发言", desc: "发帖前确认信息来源，标注不确定的部分，理性表达观点，让讨论更有价值。" },
];

export const communityRules = [
  "不编造、不传播未经证实的消息，转发前先核对来源与时间。",
  "不针对任何个人进行人身攻击、谩骂或恶意带节奏。",
  "涉及隐私的内容请勿上传，看到相关内容可点击举报交由版务处理。",
  "搬运他人内容请注明出处，尊重原作者与首发渠道。",
  "广告、外链推广与刷屏内容一律删除，严重者封禁账号。",
];

export const faqs = [
  {
    q: "黑料吃瓜网主要提供什么内容？",
    a: "本站是一个吃瓜社区聚合页，围绕娱乐圈、综艺、影视、音乐、直播等话题，提供今日热议榜、最新讨论动态、分类论坛版块与吃瓜群入口，帮助吃瓜群众快速找到围观现场与讨论聚集地。",
  },
  {
    q: "怎么加入吃瓜群？需要收费吗？",
    a: "在「吃瓜群入口」分区可以查看当前开放的群组信息与人数。所有群组均为兴趣交流群，不收取任何费用。入群后请先阅读置顶规则，遵守社区约定。",
  },
  {
    q: "本站的讨论内容都是真的吗？",
    a: "社区内容来自用户自发讨论，可能包含未经证实的信息。我们要求发帖者标注信息来源与不确定部分，也建议你在围观时保持独立判断，不将讨论内容直接当作已证实事实传播。",
  },
  {
    q: "为什么有的帖子会被删除或折叠？",
    a: "涉及隐私泄露、人身攻击、广告推广或明显编造的内容会被版务处理。如果你认为帖子的处理有疑问，可以在站务公告版块按流程反馈。",
  },
  {
    q: "新手第一次来应该从哪里开始？",
    a: "建议先看「吃瓜入门与规则」分区了解基本流程，再从今日热议榜挑一个感兴趣的话题围观，熟悉讨论氛围后再考虑注册发帖或加入吃瓜群。",
  },
  {
    q: "可以在本站发布自己的爆料吗？",
    a: "欢迎分享你亲身经历或可核实的见闻，但请勿发布针对个人的未经证实指控。发布前请确认内容不涉及隐私信息，并对可能的争议点做出说明。",
  },
];

export const tagCloud = [
  { label: "综艺花絮", count: 1286 },
  { label: "新剧开播", count: 1108 },
  { label: "红毯造型", count: 875 },
  { label: "直播名场面", count: 792 },
  { label: "新歌上线", count: 668 },
  { label: "赛后复盘", count: 601 },
  { label: "选角讨论", count: 540 },
  { label: "音乐节现场", count: 486 },
  { label: "角色设定", count: 432 },
  { label: "弹幕高能", count: 398 },
  { label: "演唱会路透", count: 356 },
  { label: "剧集口碑", count: 322 },
];

export const siteStats = [
  { value: "50,000+", label: "累计讨论帖" },
  { value: "8,100+", label: "活跃吃瓜群众" },
  { value: "12 个", label: "兴趣吃瓜群" },
  { value: "24 小时", label: "实时围观更新" },
];